module.exports = __webpack_public_path__ + "staticcomp/img/marquee.0f0f153.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/16/marquee.jpg
// module id = v2cq
// module chunks = 39